import invoiceType from '../../constants-v2/bookkeeping/invoice-type';
import { INVOICE_FILTERS } from './invoiceFilters';
import FiltersType from './listingFiltersTypesConstants';

const filters = [
  ...INVOICE_FILTERS,
  {
    key: '_is_booked',
    getItems: async () => [{ value: 0, label: 'Nie' }, { value: 1, label: 'Tak' }],
    reset: async () => null,
    placeholder: 'Zaksięgowano?',
    badge: 'Zaksięgowano:',
    testName: 'test_filter_invoice_is_booked',
    inputType: FiltersType.SELECT_TYPE,
  },
  {
    // Ustawiany m.in. kliknięciem kategorii należności w podsumowaniu (PUB-1627) — musi być
    // widoczny jako badge i możliwy do wyczyszczenia.
    key: '_paid',
    getItems: async () => [{ value: 0, label: 'Nie' }, { value: 1, label: 'Tak' }],
    reset: async () => null,
    placeholder: 'Opłacona w całości?',
    badge: 'Opłacona w całości:',
    testName: 'test_filter_invoice_paid',
    inputType: FiltersType.SELECT_TYPE,
  },
  {
    key: '_invoicetype_multi',
    getItems: async () => [
      { value: invoiceType.VAT, label: 'FAKTURA VAT' },
      { value: invoiceType.CORRECTION, label: 'FAKTURA KORYGUJĄCA' },
      { value: invoiceType.CURRENCY, label: 'FAKTURA WALUTOWA' },
      { value: invoiceType.CURRENCY_CORRECTION, label: 'KOREKTA FAKTURY WALUTOWEJ' },
      { value: invoiceType.ADVANCED, label: 'FAKTURA ZALICZKOWA' },
      { value: invoiceType.ADVANCE_CORRECTION, label: 'KOREKTA FAKTURY ZALICZKOWEJ' },
      { value: invoiceType.FINAL, label: 'FAKTURA KOŃCOWA' },
      { value: invoiceType.PROFORMA, label: 'PROFORMA' }],
    reset: async () => null,
    placeholder: 'Rodzaj faktury',
    badge: 'Rodzaj faktury:',
    testName: 'test_filter_invoice_type',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
  {
    key: '_invoice_paid_status_multi',
    getItems: async () => [
      { value: 'Opłacone', label: 'Opłacone' },
      { value: 'Nieopłacone', label: 'Nieopłacone' },
      { value: 'Częściowo', label: 'Częściowo' },
      { value: 'Nadpłata', label: 'Nadpłata' }],
    reset: async () => null,
    placeholder: 'Status płatności',
    badge: 'Status płatności:',
    testName: 'test_filter_invoice_status',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
];
export const INVOICE_MANUAL_FILTERS = {
  path: '/invoices',
  filters,
};
